/**
 * Simple utility function for mapping allocation status to user-friendly display names
 */

/**
 * Get user-friendly display name for allocation status
 * @param {string} status - The raw status value from backend
 * @returns {string} User-friendly display name
 */
export const getStatusDisplay = (status) => {
  if (!status) return 'Unknown';
  
  const statusMap = {
    // Backend enum values
    'Allocated': 'Active',
    'AllocationEnded': 'Ended',
    'FutureAllocation': 'Future Allocation',
    
    // Legacy values for backward compatibility
    'Active': 'Active',
    'Inactive': 'Ended',
    'InActive': 'Ended',
    'Future': 'Future Allocation',
    'Pending': 'Future Allocation'
  };
  
  // Check exact match first
  if (statusMap[status]) {
    return statusMap[status];
  }
  
  // Check case-insensitive match
  const normalizedStatus = status.toLowerCase();
  for (const [key, value] of Object.entries(statusMap)) {
    if (key.toLowerCase() === normalizedStatus) {
      return value;
    }
  }
  
  // Return original status if no mapping found
  return status;
};
